import { useQuery, useMutation } from "@tanstack/react-query";
import api from "../api/axiosInstance";

const getAuthHeaders = () => ({
  "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
  Authorization: `Bearer ${localStorage.getItem("access_token")}`,
});

const handle401 = (error) => {
  if (error?.response && error.response.status === 401) {
    localStorage.clear();
    window.location = "/Login";
    window.location.reload();
  }
};

export const useFetch = ({
  queryKey,
  url,
  method = "GET",
  data,
  params,
  enabled = true,
  headers,
  select,
  ...queryOptions
}) => {
  return useQuery({
    queryKey: Array.isArray(queryKey) ? queryKey : [queryKey],
    refetchOnWindowFocus: queryOptions.refetchOnWindowFocus || false,
    enabled,
    queryFn: async () => {
      try {
        const response = await api({
          method,
          url,
          data,
          params,
          headers: {
            ...getAuthHeaders(),
            ...headers,
          },
        });
        return response.data;
      } catch (error) {
        handle401(error);
        throw error;
      }
    },
    select,
    ...queryOptions,
  });
};

export const useMutate = ({
  mutationKey,
  url,
  method = "POST",
  headers,
  data,
  params,
  axiosConfig,
  ...mutationOptions
}) => {
  return useMutation({
    mutationKey,
    mutationFn: async (variables) => {
      try {
        const resolvedUrl = typeof url === "function" ? url(variables) : url;

        const response = await api({
          method,
          url: resolvedUrl,
          data: variables ?? data,
          params,
          headers: { ...getAuthHeaders(), ...headers },
          ...(axiosConfig || {}),
        });

        return response.data;
      } catch (error) {
        handle401(error);
        throw error;
      }
    },
    ...mutationOptions,
  });
};

export const buildFilterPayload = ({
  startDate,
  endDate,
  selectedSchool,
  selectedOperator,
}) => {
  let payload = {};
  const ot = localStorage.getItem("OTsReD");
  const st = localStorage.getItem("STsReD");

  if (ot != "null" && st == "null") {
    payload = {
      OperatorId: ot,
      SchoolId: parseInt(selectedSchool?.value ?? 0),
      StartDate: startDate,
      EndDate: endDate,
    };
  } else if (ot && ot !== "null" && st && st !== "null") {
    payload = {
      OperatorId: parseInt(ot),
      SchoolId: parseInt(st),
      StartDate: startDate,
      EndDate: endDate,
    };
  } else {
    payload = {
      OperatorId: selectedOperator ? parseInt(selectedOperator.value) : 0,
      SchoolId: selectedSchool ? parseInt(selectedSchool.value) : 0,
      StartDate: startDate,
      EndDate: endDate,
    };
  }
  return payload;
};
